<template>
  <CContainer class="d-flex content-center min-vh-100">
    
    <CRow>
      
      <CCol>
        <CCardGroup>
          <CCard class="p-4 login-card">
            <CCardBody>
              <CForm @submit.prevent="recover" method="POST">
                <h1>Recuperar contraseña</h1>
                <p class="text-muted">Por favor, ingrese su email y le enviaremos instrucciones para recuperar su contraseña.</p>
                <div
                  :class='message.type ? message.type : ""' 
                  class='p-2 mb-4 error-message' 
                  v-if='showMessage'>
                  <span class='ml-xl-2'>{{message.text}}</span>
                </div>
                <CInput
                  v-model="form.email"
                  prependHtml="<i class='cui-user'></i>"
                  placeholder="Email"
                  autocomplete="username email"
                  @input="hideMessage"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                
                <CRow>
                  <CCol col="12" class='pt-3'>
                    <CButton type="submit" color="primary" class="mx-auto px-4">Enviar</CButton>
                  </CCol>
                
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard
            
            text-color="white"
            class="text-center py-5 d-md-down-none logo-side "
          
          >
          <CCardBody class='d-flex'>
                      <CImg class='m-auto d-block' width='250' src='img/logo.png'></CImg>

          </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
      <CCol class='d-md-none'>
        <CImg width='250' src='img/logo.png' class='d-md-down-block d-md-up-none'></CImg>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>



    export default {
      name: 'Recuperar contraseña',
      data() {
        return {
          form: {
            email: '',
          },
          showMessage: false,
          message: {
            type: '',
            text: ''
          }
        }
      },
      methods: {

        recover(){
            this.$api.users.resetPassword(this.form)
            .then(res => {
              this.message = {
                type: 'success',
                text: res.message
              }
            })
            .catch(error => {
              this.message = {
                type: 'danger',
                text: error.response.message
              }
            })
            this.showMessage = true;
        },
        hideMessage(){
          this.showMessage = false;
        }

      }
    }

</script>

<style lang="scss">
.login-card{
  border: none;
}
.logo-side{
  background-color: #d8dbe0;
}
.error-message{
  border-radius: 4px;
}
</style>
